import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';

interface FieldEditorDrawerObjectProps {
  isNew: boolean;
  formObject: DynamicForm;
  onSave: () => void;
  onCancel: () => void;
}

export const getFieldEditorDrawerObject = ({ isNew, formObject, onSave, onCancel }: FieldEditorDrawerObjectProps): DrawerObject => {
  return {
    title: isNew ? 'dynamicDocument.addField' : 'dynamicDocument.editField',
    description: 'Vous pouvez configurer les détails de ce champ dynamique ici.',
    width: '50vw',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => onCancel(),
    actions: [
      {
        label: isNew ? 'Enregistrer' : 'Modifier',
        onClick: () => onSave(),
      },
      {
        label: 'Annuler',
        onClick: () => onCancel(),
        variant: 'secondary',
      },
    ],
  };
};
